// Layouts scroll inside a container rather than the window, so the router's own scroll handling never reaches it
export const getScrollContainer = (): HTMLElement | null => document.querySelector<HTMLElement>('[data-scroll-container]')

export const scrollPositions = new Map<string, number>()
